import React from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = React.lazy(() => import('../pages/home/page'));
const AboutPage = React.lazy(() => import('../pages/about/page'));
const ServicesPage = React.lazy(() => import('../pages/services/page'));
const ContactPage = React.lazy(() => import('../pages/contact/page'));
const AppointmentPage = React.lazy(() => import('../pages/appointment/page'));
const GalleryPage = React.lazy(() => import('../pages/gallery/page'));
const FAQPage = React.lazy(() => import('../pages/faq/page'));
const FeesPage = React.lazy(() => import('../pages/fees/page'));
const LocationPage = React.lazy(() => import('../pages/location/page'));
const NewResidentPage = React.lazy(() => import('../pages/new-resident/page'));
const RequiredDocumentsPage = React.lazy(() => import('../pages/required-documents/page'));
const DMVProcessesPage = React.lazy(() => import('../pages/dmv-processes/page'));

const VehicleRegistrationPage = React.lazy(() => import('../pages/vehicle-registration/page'));
const TitleTransferPage = React.lazy(() => import('../pages/title-transfer/page'));
const LicensePlatesPage = React.lazy(() => import('../pages/license-plates/page'));
const TemporaryPermitsPage = React.lazy(() => import('../pages/temporary-permits/page'));
const DuplicateTitlePage = React.lazy(() => import('../pages/duplicate-title/page'));
const NotaryServicesPage = React.lazy(() => import('../pages/notary-services/page'));

const VehicleRegistrationServicePage = React.lazy(() => import('../pages/vehicle-registration-service/page'));
const TitleTransferServicePage = React.lazy(() => import('../pages/title-transfer-service/page'));
const LicensePlatesServicePage = React.lazy(() => import('../pages/license-plates-service/page'));
const TemporaryPermitsServicePage = React.lazy(() => import('../pages/temporary-permits-service/page'));
const DuplicateTitleServicePage = React.lazy(() => import('../pages/duplicate-title-service/page'));
const NotaryServicesDetailPage = React.lazy(() => import('../pages/notary-services-page/page'));

// SEO Educational Pages
const NevadaDMVInfoPage = React.lazy(() => import('../pages/nevada-dmv-info/page'));
const DMVFormsPage = React.lazy(() => import('../pages/dmv-forms/page'));
const NevadaVehicleRegistrationGuidePage = React.lazy(() => import('../pages/nevada-vehicle-registration-guide/page'));
const NevadaRegistrationRenewalPage = React.lazy(() => import('../pages/nevada-registration-renewal/page'));
const NevadaRegistrationFeesPage = React.lazy(() => import('../pages/nevada-registration-fees/page'));
const NevadaLateRegistrationPenaltiesPage = React.lazy(() => import('../pages/nevada-late-registration-penalties/page'));
const NevadaNonOperationAffidavitPage = React.lazy(() => import('../pages/nevada-non-operation-affidavit/page'));
const NevadaNewResidentRegistrationPage = React.lazy(() => import('../pages/nevada-new-resident-registration/page'));
const NevadaTitleTransferGuidePage = React.lazy(() => import('../pages/nevada-title-transfer-guide/page'));
const NevadaDuplicateTitlePage = React.lazy(() => import('../pages/nevada-duplicate-title/page'));
const NevadaSalvageTitlePage = React.lazy(() => import('../pages/nevada-salvage-title/page'));
const NevadaLienReleasePage = React.lazy(() => import('../pages/nevada-lien-release/page'));
const NevadaTitleAfterDeathPage = React.lazy(() => import('../pages/nevada-title-after-death/page'));
const NevadaPrivatePartySalePage = React.lazy(() => import('../pages/nevada-private-party-sale/page'));
const NevadaSmogEmissionsGuidePage = React.lazy(() => import('../pages/nevada-smog-emissions-guide/page'));
const NevadaVINInspectionPage = React.lazy(() => import('../pages/nevada-vin-inspection/page'));
const NevadaOHVRegistrationPage = React.lazy(() => import('../pages/nevada-ohv-registration/page'));
const NevadaTrailerRegistrationPage = React.lazy(() => import('../pages/nevada-trailer-registration/page'));
const NevadaCommercialVehiclePage = React.lazy(() => import('../pages/nevada-commercial-vehicle/page'));
const NevadaTemporaryPermitsGuidePage = React.lazy(() => import('../pages/nevada-temporary-permits-guide/page'));
const NevadaLicensePlatesGuidePage = React.lazy(() => import('../pages/nevada-license-plates-guide/page'));
const NevadaSpecialtyPlatesPage = React.lazy(() => import('../pages/nevada-specialty-plates/page'));
const NevadaDriversLicenseGuidePage = React.lazy(() => import('../pages/nevada-drivers-license-guide/page'));
const NevadaRealIDPage = React.lazy(() => import('../pages/nevada-real-id/page'));
const NevadaPowerOfAttorneyVehiclePage = React.lazy(() => import('../pages/nevada-power-of-attorney-vehicle/page'));

const NotFoundPage = React.lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/appointment', element: <AppointmentPage /> },
  { path: '/gallery', element: <GalleryPage /> },
  { path: '/faq', element: <FAQPage /> },
  { path: '/fees', element: <FeesPage /> },
  { path: '/location', element: <LocationPage /> },
  { path: '/new-resident', element: <NewResidentPage /> },
  { path: '/required-documents', element: <RequiredDocumentsPage /> },
  { path: '/dmv-processes', element: <DMVProcessesPage /> },

  { path: '/vehicle-registration', element: <VehicleRegistrationPage /> },
  { path: '/title-transfer', element: <TitleTransferPage /> },
  { path: '/license-plates', element: <LicensePlatesPage /> },
  { path: '/temporary-permits', element: <TemporaryPermitsPage /> },
  { path: '/duplicate-title', element: <DuplicateTitlePage /> },
  { path: '/notary-services', element: <NotaryServicesPage /> },

  { path: '/vehicle-registration-service', element: <VehicleRegistrationServicePage /> },
  { path: '/title-transfer-service', element: <TitleTransferServicePage /> },
  { path: '/license-plates-service', element: <LicensePlatesServicePage /> },
  { path: '/temporary-permits-service', element: <TemporaryPermitsServicePage /> },
  { path: '/duplicate-title-service', element: <DuplicateTitleServicePage /> },
  { path: '/notary-services-detail', element: <NotaryServicesDetailPage /> },

  // SEO Educational Hub
  { path: '/nevada-dmv-info', element: <NevadaDMVInfoPage /> },
  { path: '/nevada-dmv-forms', element: <DMVFormsPage /> },

  // Vehicle Registration SEO Pages
  { path: '/nevada-vehicle-registration-guide', element: <NevadaVehicleRegistrationGuidePage /> },
  { path: '/nevada-registration-renewal', element: <NevadaRegistrationRenewalPage /> },
  { path: '/nevada-registration-fees', element: <NevadaRegistrationFeesPage /> },
  { path: '/nevada-late-registration-penalties', element: <NevadaLateRegistrationPenaltiesPage /> },
  { path: '/nevada-non-operation-affidavit', element: <NevadaNonOperationAffidavitPage /> },
  { path: '/nevada-new-resident-registration', element: <NevadaNewResidentRegistrationPage /> },

  // Title & Ownership SEO Pages
  { path: '/nevada-title-transfer-guide', element: <NevadaTitleTransferGuidePage /> },
  { path: '/nevada-duplicate-title', element: <NevadaDuplicateTitlePage /> },
  { path: '/nevada-salvage-title', element: <NevadaSalvageTitlePage /> },
  { path: '/nevada-lien-release', element: <NevadaLienReleasePage /> },
  { path: '/nevada-title-after-death', element: <NevadaTitleAfterDeathPage /> },
  { path: '/nevada-private-party-sale', element: <NevadaPrivatePartySalePage /> },

  // Emissions & Inspections SEO Pages
  { path: '/nevada-smog-emissions-guide', element: <NevadaSmogEmissionsGuidePage /> },
  { path: '/nevada-vin-inspection', element: <NevadaVINInspectionPage /> },

  // Specialty Vehicles SEO Pages
  { path: '/nevada-ohv-registration', element: <NevadaOHVRegistrationPage /> },
  { path: '/nevada-trailer-registration', element: <NevadaTrailerRegistrationPage /> },
  { path: '/nevada-commercial-vehicle', element: <NevadaCommercialVehiclePage /> },
  { path: '/nevada-temporary-permits-guide', element: <NevadaTemporaryPermitsGuidePage /> },

  // License Plates SEO Pages
  { path: '/nevada-license-plates-guide', element: <NevadaLicensePlatesGuidePage /> },
  { path: '/nevada-specialty-plates', element: <NevadaSpecialtyPlatesPage /> },

  // Driver's License SEO Pages
  { path: '/nevada-drivers-license-guide', element: <NevadaDriversLicenseGuidePage /> },
  { path: '/nevada-real-id', element: <NevadaRealIDPage /> },

  // DMV Processes SEO Pages
  { path: '/nevada-power-of-attorney-vehicle', element: <NevadaPowerOfAttorneyVehiclePage /> },

  { path: '*', element: <NotFoundPage /> },
];

export default routes;
